export default __webpack_public_path__ + "static/media/french-flag.1116a569.svg";